import { SetStateAction, useEffect, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { SelectPicker, CheckPicker, Checkbox } from "rsuite";
import {
	getBaselineCategorySummary,
	getBaselineDistrictSummaryByL4,
	getBaselineL4ForTopSuppliers,
	getBaselineMapView,
	getBaselineParetoChart,
	getBaselineSPaUtilization,
	getBaselineSupplierSummary,
	getBaselineVendorSpa,
	getBaselineFilters,
	getBaselineKPIs,
	getL4MaterialSummary,
	getSkuParetoExport,
} from "../../queries/apiQueries";
import SupplierSpendByCategory from "./supplier-summary/supplierSpendByCategory";
import TopSuppliersBySpend from "./supplier-summary/topSuppliersBySpend";
import DistrictSpendByL4 from "./district-summary/districtSpendByL4";
import SupplierPareto from "./pareto-chart/supplierPareto";
import SKUPareto from "./pareto-chart/skuPareto";
import MapView from "./district-summary/map-view";
import { FILTERDATA, TIMELINE, numberFormatter } from "../../utils";
import "./baseline.scss";
import L1Profile from "./category-Summary/l1Profile";
import L2Profile from "./category-Summary/l2Profile";
import L3Profile from "./category-Summary/l3Profile";
import SKUParetoTable from "./pareto-chart/skuParetoTable";
import BubbleChart from "./bubbleChart";
import SKUCountTable from "./spa-summary/skuCountTable";
import L4SummaryTable from "./l4SummaryTable";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { CSVLink } from "react-csv";
import { appInsights } from "../router";
import { projectType, addressableSpend } from "../constants";
import MainHeader from "../../components/Layouts/MainHeader";
import MainContent from "../../components/Layouts/MainContent";
import TableTitle from "../../components/common/Table/TableTitle";
import { Segmented } from "antd";
import { Loader } from "../../components/common/Loader";
import { getTimelineOptions } from "../../config/constants";


const CategoryBaseline = (props: any) => {
	const footerStyles = {
		padding: "10px 2px",
		borderTop: "1px solid #e5e5e5",
	};

	const didMount: any = useRef(false);
	var isCleared = false;
	const allFilters = useSelector(
		(state: any) => state.CommonReducer.allFilters
	);
	const token = useSelector((state: any) => state.CommonReducer.token);
	const timeline = useSelector((state: any) => state.CommonReducer.timeline);
	var isCl;
	const dispatch = useDispatch<any>();
	const [filtersLoading, setFiltersLoading] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [getSpaGM, setGetSpaGM] = useState(0);
	const [filterOptions, updateFilterOptions] = useState<any>({
		district: new Array<{ district: string }>(),
		l1: new Array<{ l1: string }>(),
		l2: new Array<{ l2: string }>(),
		l3: new Array<{ l3: string }>(),
		supplier: new Array<{ vendor: string }>(),
	});
	const [selectedFilters, setSelectedFilters] = useState<any>(allFilters);
	const [isVisible, setIsVisible] = useState(false);
	const [currentFilterSelected, setCurrentFilterSelected] =
		useState<any>(null);
	const [skuParetoExportData, setSkuParetoExportData] = useState<any>([]);
	const [districtSummaryExportData, setDistrictSummaryExportData] =
		useState<any>([]);
	const [selectedProjectType, setSelectedProjectType] = useState(
		projectType.length && projectType[2].value
	);
	const [selectedAddressableSpend, setSelectedAddressableSpend] = useState(
		addressableSpend.length && addressableSpend[0].value
	);

	// categorySummary
	const [categorySummary, setCategorySummary] = useState<any>({});
	// supplierSummary.1
	const [supplierSummary, setSupplierSummary] = useState<any>([]);
	const [selectedCategories, setSelectedCategories] = useState<any>({
		L1: allFilters?.l1?.length !== 0 ? allFilters?.l1 : null,
		L2: allFilters?.l2?.length !== 0 ? allFilters?.l2 : null,
		L3: allFilters?.l3?.length !== 0 ? allFilters?.l3 : null,
	});
	// supplierSummary.2
	const [topSuppliersByL4, setTopSuppliersByL4] = useState<any>([]);
	// districtSummar.2
	const [districtSpendByL4, setDistrictSpendByL4] = useState<any>([]);

	const [kpiData, setKpiData] = useState<any>([]);
	const [l4SummaryData, setL4SummaryData] = useState<any>([]);

	const [mapData, setMapData] = useState<any>([]);
	const [mapLegends, setMapLegends] = useState<any>([]);

	const [pareto, setPareto] = useState<any>({});
	const [refArea, setRefArea] = useState<any>({});
	const [skuRefArea, setSkuRefArea] = useState<any>({});
	const [isRightVisible, setIsRightVisible] = useState(false);
	const [spaUtilScatterData, setSpaUtilScatterData] = useState<any>([]);
	const [timelineOptions, setTimelineOptions] = useState<any[]>(getTimelineOptions());

	const [selectedTimeline, setSelectedTimeline] = useState(
		timeline ? timeline : timelineOptions.length && timelineOptions[0].value
	);
	const [selectedButton, setSelectedButton] = useState("category-summary");
	const [spaVendorData, setSpaVendorData] = useState<any>([]);
	const [updatedCategory, setUpdatedCategory] = useState<any>(null);
	const [spaUtilizationExportData, setSpaUtilizationExportData] =
		useState<any>([]);
	const [districtMapExportData, setDistrictMapExportData] = useState<any>([]);
	const [pageNumber, setPageNumber] = useState(1);
	const [supplierSummaryCount, setSupplierSummaryCount] = useState(0);
	const [supplierSummaryVisible, setSupplierSummaryVisible] = useState(false);

	const filtersMount: any = useRef(false);

	const exportFullRef = useRef<any>(null);
	const exportMapFullRef = useRef<any>(null);

	const csvHeaders = [
		{ label: "L1", key: "l1" },
		{ label: "L2", key: "l2" },
		{ label: "L3", key: "l3" },
		{ label: "Part Number", key: "MAN_PART_NO" },
		{ label: "Material Number", key: "MATERIAL_MATERIAL" },
		{ label: "Total Transaction", key: "totalLineItems" },
		{ label: "Sales($)", key: "sales_2023" },
		{ label: "Supplier Name", key: "master_vendor_name" },
		{ label: "Gross Margin", key: "grossMargin" },
		{ label: "SPA Util Group", key: "highSpaFlag" },
		{ label: "Spa Utilization", key: "spaPercent" },
	];

	const csvMapHeaders = [
		{ label: "L1", key: "l1" },
		{ label: "L2", key: "l2" },
		{ label: "L3", key: "l3" },
		{ label: "District", key: "district" },
		{ label: "Supplier", key: "supplier" },
		{ label: "Spend", key: "netcost" },
	];

	const exportData = () => {
		if (spaUtilizationExportData?.length !== 0) {
			exportFullRef?.current?.link.click();
		}
	};

	const exportMapData = () => {
		if (districtMapExportData?.length !== 0) {
			exportMapFullRef?.current?.link.click();
		}
	};

	useEffect(() => {
		appInsights.trackPageView({
			name: `Navigate to Category Baseline by ${localStorage.getItem(
				"name"
			)}`,
		});
		if (token) {
			setIsLoading(true);
			getCategorySummary();
			getFilters();
			getKPIData();
		}
	}, [token]);

	useEffect(() => {
		if (token) {
			if (didMount.current) {
				getCategorySummary();
				getSupplierSummary();
				getKPIData();
				getL4ForTopSuppliers();
				getDistrictSummaryByL4();
				getL4SummaryData();
				getMapData();
				getParetoChartData();
				getSpaUtilSummary();
			}
		}
	}, [updatedCategory]);

	useEffect(() => {
		props?.onFilterChange(selectedFilters);
	}, [selectedFilters]);

	useEffect(() => {
		let filterValues: any = {
			l1:
				selectedCategories?.L1?.length > 0
					? Array.isArray(selectedCategories.L1)
						? selectedCategories.L1
						: [selectedCategories.L1]
					: [],
			l2:
				selectedCategories?.L2?.length > 0
					? Array.isArray(selectedCategories.L2)
						? selectedCategories.L2
						: [selectedCategories.L2]
					: [],
			l3:
				selectedCategories?.L3?.length > 0
					? Array.isArray(selectedCategories.L3)
						? selectedCategories.L3
						: [selectedCategories.L3]
					: [],
			supplier: [],
			district: [],
		};
		props?.onFilterChange(filterValues);
	}, [selectedCategories]);

	useEffect(() => {
		if (token) {
			if (
				didMount.current ||
				allFilters?.l2?.length !== 0 ||
				allFilters?.l3?.length !== 0
			) {
				if (Object.keys(selectedFilters).length > 0) {
					setSelectedCategories({
						L1:
							selectedFilters?.l1?.length !== 0
								? selectedFilters?.l1
								: null,
						L2:
							selectedFilters?.l2?.length !== 0
								? selectedFilters?.l2
								: null,
						L3:
							selectedFilters?.l3?.length !== 0
								? selectedFilters?.l3
								: null,
					});

					if (
						(currentFilterSelected === "l1" &&
							selectedCategories.L1 === selectedFilters?.l1) ||
						(currentFilterSelected === "l2" &&
							selectedCategories.L2 === selectedFilters?.l2)
					) {
						getCategorySummary();
						getKPIData();
					}

					if (
						selectedCategories.L2 === selectedFilters?.l2 &&
						(currentFilterSelected === "l2" ||
							(allFilters?.l2?.length !== 0 &&
								allFilters?.l3?.length === 0))
					) {
						getSupplierSummary();
					}

					if (
						selectedCategories.L3 === selectedFilters?.l3 &&
						(currentFilterSelected === "l3" ||
							allFilters?.l3?.length !== 0)
					) {
						getL4ForTopSuppliers();
						getDistrictSummaryByL4();
						getL4SummaryData();
						getMapData();
						getParetoChartData();
						getSupplierSummary();
						getCategorySummary({
							l1: selectedCategories.L1
								? Array.isArray(selectedCategories.L1)
									? selectedCategories.L1
									: [selectedCategories.L1]
								: [],
							l2: selectedCategories.L2
								? Array.isArray(selectedCategories.L2)
									? selectedCategories.L2
									: [selectedCategories.L2]
								: [],
							l3: selectedCategories.L3
								? Array.isArray(selectedCategories.L3)
									? selectedCategories.L3
									: [selectedCategories.L3]
								: [],
							timeline: [selectedTimeline],
						});
						getKPIData();
						getSpaUtilSummary();
					}
				}
			}
		}
	}, [selectedFilters]);

	useEffect(() => {
		if (currentFilterSelected === "timeline") {
			props.onTimelineChange(selectedTimeline);
		}
		if (token) {
			if (
				currentFilterSelected === "timeline" ||
				currentFilterSelected === "projectType"
			) {
				getCategorySummary();
				getKPIData();
				if (
					selectedFilters?.l2?.length > 0 ||
					selectedCategories?.L2?.length > 0
				) {
					getSupplierSummary();
				}
				if (
					selectedFilters?.l3?.length > 0 ||
					selectedCategories?.L3?.length > 0
				) {
					getSupplierSummary();
					getL4ForTopSuppliers();
					getDistrictSummaryByL4();
					getL4SummaryData();
					getMapData();
					getParetoChartData();
					getSpaUtilSummary();
				}
			}
		}
	}, [selectedTimeline, selectedProjectType]);

	useEffect(() => {
		if (token) {
			if (didMount.current) {
				getCategorySummary();
				getSupplierSummary();
				getDistrictSummaryByL4();
				getParetoChartData();
				getMapData();
				getKPIData();
			}
		}
	}, [selectedAddressableSpend]);

	/* Filters api call */
	const getFilters = async (
		payload: any = {},
		currentFilter: any = "all",
		fo: any = null
	) => {
		setFiltersLoading(true);
		setUpdatedCategory(null);
		let res = await dispatch(getBaselineFilters(payload));
		setTimeout(() => {
			setFiltersLoading(false);
		}, 100);
		if (fo) {
			if (currentFilter === "l1") {
				updateFilterOptions({
					...fo,
					l2: [...res.l2],
					l3: [...res.l3],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...fo,
					l3: [...res.l3],
				});
			} else {
				updateFilterOptions({
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
				});
			}
		} else {
			if (currentFilter === "l1") {
				updateFilterOptions({
					...filterOptions,
					l2: [...res.l2],
					l3: [...res.l3],
				});
			} else if (currentFilter === "l2") {
				updateFilterOptions({
					...filterOptions,
					l3: [...res.l3],
				});
			} else if (currentFilter === "l3") {
				updateFilterOptions({ ...filterOptions });
			} else {
				updateFilterOptions({
					l1: res.l1,
					l2: res.l2,
					l3: res.l3,
				});
			}
		}
		filtersMount.current = false;
		return res;
	};

	/* on changing project type */
	const projectTypeHandler = (e: any) => {
		setSelectedProjectType(e === null ? "All" : e);
		setCurrentFilterSelected("projectType");
	};

	/* on changing addressable spend */
	const addressableSpendHandler = (e: any) => {
		setSelectedAddressableSpend(e === null ? "All" : e);
		// setCurrentFilterSelected("addressableSpend");
	};

	/* Updating filter selection state  */
	const handleFilterUpdate = (value: any, filter: string) => {
		if (isCleared) {
			isCleared = false;
			return;
		}
		filtersMount.current = true;
		let x: string = filter;
		if (value === "all") {
			if (filterOptions?.[x].length === selectedFilters?.[x].length) {
				setSelectedFilters({ ...selectedFilters, [x]: [] });
			} else {
				if (x == "supplier") {
					setSelectedFilters({
						...selectedFilters,
						[x]: [
							...filterOptions?.[x].map(
								(option: any) => option.vendor
							),
						],
					});
				} else {
					setSelectedFilters({
						...selectedFilters,
						[x]: [
							...filterOptions?.[x].map(
								(option: any) => option?.[x]
							),
						],
					});
				}
			}
		} else {
			setSelectedFilters({ ...selectedFilters, [x]: [...value] });
			setCurrentFilterSelected(x);
		}
	};

	/* Updating filter options based on selection (api) */
	const handleClose = (filter: string) => {
		if (filter === "l1") {
			setSelectedFilters({ ...selectedFilters, l2: [], l3: [] });
			setSelectedCategories({
				...selectedCategories,
				L2: null,
				L3: null,
			});
			getFilters({ ...selectedFilters, l2: [], l3: [] }, "l1");
		} else if (filter === "l2") {
			setSelectedFilters({ ...selectedFilters, l3: [] });
			setSelectedCategories({ ...selectedCategories, L3: null });
			getFilters({ ...selectedFilters, l3: [] }, "l2");
		} else if (filter === "l3") {
			setSelectedFilters({ ...selectedFilters });
			setSelectedCategories({ ...selectedCategories });
			getFilters({ ...selectedFilters }, "l3");
		}
	};

	const handleClear = (filter: string) => {
		isCleared = true;
		if (filter === "l1") {
			setSelectedFilters({
				...selectedFilters,
				l1: [],
				l2: [],
				l3: [],
			});
			getFilters({ ...selectedFilters, l1: [], l2: [], l3: [] }, "l1");
			getCategorySummary({
				l1: [],
				l2: [],
				timeline: [selectedTimeline],
			});
			getKPIData({
				l1: [],
				l2: [],
				l3: [],
				timeline: [selectedTimeline],
			});
			handleL1Selection(null);
			// getSummaryData({ ...selectedFilters, l1: [], l2: [], l3: [], supplier: [] });
		} else if (filter === "l2") {
			setSelectedFilters({ ...selectedFilters, l2: [], l3: [] });
			getFilters({ ...selectedFilters, l2: [], l3: [] }, "l2");
			getCategorySummary({
				l1: selectedCategories.L1
					? Array.isArray(selectedCategories.L1)
						? selectedCategories.L1
						: [selectedCategories.L1]
					: [],
				l2: [],
				l3: [],
				timeline: [selectedTimeline],
			});
			getKPIData({
				l1: selectedCategories.L1
					? Array.isArray(selectedCategories.L1)
						? selectedCategories.L1
						: [selectedCategories.L1]
					: [],
				l2: [],
				l3: [],
				timeline: [selectedTimeline],
			});
			handleL2Selection(null);
		} else if (filter === "l3") {
			// handleClose('l2');
			setSelectedFilters({ ...selectedFilters, l3: [] });
			getFilters({ ...selectedFilters, l3: [] }, "l3");
			getCategorySummary({
				l1: selectedCategories.L1
					? Array.isArray(selectedCategories.L1)
						? selectedCategories.L1
						: [selectedCategories.L1]
					: [],
				l2: selectedCategories.L2
					? Array.isArray(selectedCategories.L2)
						? selectedCategories.L2
						: [selectedCategories.L2]
					: [],
				l3: [],
				timeline: [selectedTimeline],
			});
			getKPIData({
				l1: selectedCategories.L1
					? Array.isArray(selectedCategories.L1)
						? selectedCategories.L1
						: [selectedCategories.L1]
					: [],
				l2: selectedCategories.L2
					? Array.isArray(selectedCategories.L2)
						? selectedCategories.L2
						: [selectedCategories.L2]
					: [],
				l3: [],
				timeline: [selectedTimeline],
			});
			handleL3Selection(null);
		}
	};

	/* on changing timeline */
	const timelineHandler = (e: any) => {
		setSelectedTimeline(e === null ? "All" : e);
		setCurrentFilterSelected("timeline");
	};

	const getSelectedCategories = () => {
		let l1Categories = "";
		let l2Categories = "";
		let l3Categories = "";
		if (selectedCategories.L1) {
			if (Array.isArray(selectedCategories.L1)) {
				selectedCategories.L1.map((item: any, index: any) => {
					l1Categories =
						l1Categories +
						item +
						(selectedCategories.L1.length > index + 1 ? ", " : " ");
				});
			} else {
				l1Categories = l1Categories + selectedCategories.L1;
			}
		}
		if (selectedCategories.L2) {
			if (Array.isArray(selectedCategories.L2)) {
				selectedCategories.L2.map((item: any, index: any) => {
					l2Categories =
						l2Categories +
						item +
						(selectedCategories.L2.length > index + 1 ? ", " : " ");
				});
			} else {
				l2Categories = l2Categories + selectedCategories.L2;
			}
		}
		if (selectedCategories.L3) {
			if (Array.isArray(selectedCategories.L3)) {
				selectedCategories.L3.map((item: any, index: any) => {
					l3Categories =
						l3Categories +
						item +
						(selectedCategories.L3.length > index + 1 ? ", " : " ");
				});
			} else {
				l3Categories = l3Categories + selectedCategories.L3;
			}
		}
		let categories =
			(l1Categories.length > 0 ? " | " + l1Categories : "") +
			(l2Categories.length > 0 ? " | " + l2Categories : "") +
			(l3Categories.length > 0 ? " | " + l3Categories : "");
		return categories;
	};

	const getCategorySummary = async (payload: any = {}) => {
		if (Object.keys(payload).length === 0) {
			payload = {
				l1: selectedCategories.L1
					? Array.isArray(selectedCategories.L1)
						? selectedCategories.L1
						: [selectedCategories.L1]
					: [],
				l2: selectedCategories.L2
					? Array.isArray(selectedCategories.L2)
						? selectedCategories.L2
						: [selectedCategories.L2]
					: [],
				l3: selectedCategories.L3
					? Array.isArray(selectedCategories.L3)
						? selectedCategories.L3
						: [selectedCategories.L3]
					: [],
				timeline: [selectedTimeline],
			};
		}
		payload.projectType = selectedProjectType;
		payload.nofInd = selectedAddressableSpend;
		let res = await dispatch(getBaselineCategorySummary(payload));
		if (res?.data) {
			// if (updatedCategory?.split("_")[0] == "l1") {
			//   setCategorySummary({
			//     ...categorySummary,
			//     L2: res.data.L2,
			//     L3: res.data.L3,
			//   });
			// } else if (updatedCategory?.split("_")[0] == "l2") {
			//   setCategorySummary({ ...categorySummary, L3: res.data.L3 });
			// } else if (updatedCategory?.split("_")[0] == "l3") {
			//   setCategorySummary({ ...categorySummary });
			// } else {
			setCategorySummary(res.data);
			// }
		}
		setIsLoading(false);
		didMount.current = true;
	};

	const getKPIData = async (payload: any = {}) => {
		if (Object.keys(payload).length === 0) {
			payload = {
				l1: selectedCategories.L1
					? Array.isArray(selectedCategories.L1)
						? selectedCategories.L1
						: [selectedCategories.L1]
					: [],
				l2: selectedCategories.L2
					? Array.isArray(selectedCategories.L2)
						? selectedCategories.L2
						: [selectedCategories.L2]
					: [],
				l3: selectedCategories.L3
					? Array.isArray(selectedCategories.L3)
						? selectedCategories.L3
						: [selectedCategories.L3]
					: [],
				timeline: [selectedTimeline],
			};
		}
		payload.projectType = selectedProjectType;
		payload.nofInd = selectedAddressableSpend;
		let res = await dispatch(getBaselineKPIs(payload));
		if (res?.data) {
			setKpiData(res.data[0]);
		}
	};

	const getL4SummaryData = async (payload: any = {}) => {
		payload = {
			l1: selectedCategories.L1
				? Array.isArray(selectedCategories.L1)
					? selectedCategories.L1
					: [selectedCategories.L1]
				: [],
			l2: selectedCategories.L2
				? Array.isArray(selectedCategories.L2)
					? selectedCategories.L2
					: [selectedCategories.L2]
				: [],
			l3: selectedCategories.L3
				? Array.isArray(selectedCategories.L3)
					? selectedCategories.L3
					: [selectedCategories.L3]
				: [],
			timeline: [selectedTimeline],
		};
		payload.projectType = selectedProjectType;
		let res = await dispatch(getL4MaterialSummary(payload));
		if (res?.data) {
			setL4SummaryData(res.data);
		}
	};

	const getSkuParetoExportData = async (payload: any = {}) => {
		payload = {
			l1: selectedCategories.L1
				? Array.isArray(selectedCategories.L1)
					? selectedCategories.L1
					: [selectedCategories.L1]
				: [],
			l2: selectedCategories.L2
				? Array.isArray(selectedCategories.L2)
					? selectedCategories.L2
					: [selectedCategories.L2]
				: [],
			l3: selectedCategories.L3
				? Array.isArray(selectedCategories.L3)
					? selectedCategories.L3
					: [selectedCategories.L3]
				: [],
			timeline: [selectedTimeline],
		};
		payload.projectType = selectedProjectType;
		let res = await dispatch(getSkuParetoExport(payload));
		if (res) {
			res.sort((x: any, y: any) => y.GM$ - x.GM$);

			let finalData: any[] = [];
			// finalData.push({ MATERIAL_MATERIAL: "Loss Leader SKU: Low Margin | Basket: High Margin", gmPercent: " ", gmCategory: " " });
			res.map((item: any, key: any) => {
				if (item.GM_Upper_Limit) {
					item["Min_Sales_Doc_GM%"] = item["Min_Sales_Doc_GM%"]
						? `${numberFormatter(
								item["Min_Sales_Doc_GM%"] * 100,
								2
						  )}%`
						: null;
					item["SKU_GM%"] = `${numberFormatter(item["SKU_GM%"], 2)}%`;
				}
				if (item.paretoFlag == "loss leaders") {
					item.paretoFlag = "Loss Leaders";
				} else if (item.paretoFlag == "not loss leader") {
					item.paretoFlag = "Not Loss Leader";
				} else if (item.paretoFlag == "uniquely purchased") {
					item.paretoFlag = "Purchased Individually";
				} else if (item.paretoFlag === "Not in Scope") {
					item.paretoFlag = null;
				}

				item["SKU_GM%"] = item["SKU_GM%"]
					? `${numberFormatter(item["SKU_GM%"] * 100, 2)}%`
					: "";
				item["GM$"] = item["GM$"] ? `$${item["GM$"].toFixed(0)}` : "";
				item.cost = item.cost ? `$${item.cost.toFixed(0)}` : "";

				finalData.push(item);
			});

			// finalData.push({ MATERIAL_MATERIAL: "SKU & Basket: Low Margin", gmPercent: " ", gmCategory: " " });
			// res.map((item:any, key:any)=>{
			//   if(item?.paretoFlag == 'not loss leader' && item?.gmPercent){
			//   finalData.push({ MATERIAL_MATERIAL: item?.MATERIAL_MATERIAL, gmPercent: `${numberFormatter(item?.gmPercent,2)}%`, gmCategory: (item?.under14 == 'In Bucket' ? 'Gross Margin (0 - 14%)' : 'Gross Margin (14 - 20%)')});
			//   }
			// })

			// // finalData.push({ MATERIAL_MATERIAL: "Purchased Individually", gmPercent: " ", gmCategory: " " });
			// res.map((item:any, key:any)=>{
			//   if(item?.paretoFlag == 'uniquely purchased' && item?.gmPercent){
			//   finalData.push({ MATERIAL_MATERIAL: item?.MATERIAL_MATERIAL, gmPercent: `${numberFormatter(item?.gmPercent,2)}%`, gmCategory: (item?.under14 == 'In Bucket' ? 'Gross Margin (0 - 14%)' : 'Gross Margin (14 - 20%)')});
			//   }
			// })

			setSkuParetoExportData(finalData);
		}
	};

	const getSupplierSummary = async (payload: any = {}, page: number = 1) => {
		payload = {
			l1: selectedCategories.L1
				? Array.isArray(selectedCategories.L1)
					? selectedCategories.L1
					: [selectedCategories.L1]
				: [],
			l2: selectedCategories.L2
				? Array.isArray(selectedCategories.L2)
					? selectedCategories.L2
					: [selectedCategories.L2]
				: [],
			l3: selectedCategories.L3
				? Array.isArray(selectedCategories.L3)
					? selectedCategories.L3
					: [selectedCategories.L3]
				: [],
			timeline: [selectedTimeline],
			pageNumber: page,
			projectType: selectedProjectType,
			nofInd: selectedAddressableSpend,
		};
		setPageNumber(page);

		// If your API returns {res: {data: [], total: number}}, use this:
		let res = await dispatch(getBaselineSupplierSummary(payload));
		res = res?.res; // <-- This is important if your API wraps the response

		if (res?.data) {
			res.data = res.data.map((d: any) => {
				for (let supp of d.spendPerSupplier) {
					d[supp.supplier] = supp.costPercent;
				}
				return d;
			});
			setSupplierSummary(res.data);
			setSupplierSummaryCount(res?.total);
			setSupplierSummaryVisible(true);
		}
	};

	const getL4ForTopSuppliers = async (payload: any = {}) => {
		if (false) {
			payload = {
				l1: selectedCategories.L1
					? Array.isArray(selectedCategories.L1)
						? selectedCategories.L1
						: [selectedCategories.L1]
					: [],
				l2: selectedCategories.L2
					? Array.isArray(selectedCategories.L2)
						? selectedCategories.L2
						: [selectedCategories.L2]
					: [],
				l3: selectedCategories.L3
					? Array.isArray(selectedCategories.L3)
						? selectedCategories.L3
						: [selectedCategories.L3]
					: [],
				timeline: [selectedTimeline],
			};
			payload.projectType = selectedProjectType;
			let res = await dispatch(getBaselineL4ForTopSuppliers(payload));
			if (res?.data) {
				res.data.sort(
					(x: any, y: any) => y.Spend_percentage - x.Spend_percentage
				);
				res.data = res.data.map((d: any) => {
					for (let cat of d.l4spend) {
						d[cat.category] = cat.spend;
					}
					d?.l4spend?.sort((x: any, y: any) => y.spend - x.spend);
					return d;
				});
				setTopSuppliersByL4(res.data);
			}
		}
	};

	const getDistrictSummaryByL4 = async (payload: any = {}) => {
		if (selectedCategories.L3) {
			payload = {
				l1: selectedCategories.L1
					? Array.isArray(selectedCategories.L1)
						? selectedCategories.L1
						: [selectedCategories.L1]
					: [],
				l2: selectedCategories.L2
					? Array.isArray(selectedCategories.L2)
						? selectedCategories.L2
						: [selectedCategories.L2]
					: [],
				l3: selectedCategories.L3
					? Array.isArray(selectedCategories.L3)
						? selectedCategories.L3
						: [selectedCategories.L3]
					: [],
				timeline: [selectedTimeline],
			};
			payload.projectType = selectedProjectType;
			payload.nofInd = selectedAddressableSpend;
			let res = await dispatch(getBaselineDistrictSummaryByL4(payload));
			if (res?.data) {
				res.data.sort((x: any, y: any) => y.netcost - x.netcost);
				res.data = res.data.map((d: any) => {
					for (let cat of d.l4Spend) {
						d[cat.category] = cat.costPercent;
					}
					d.l4Spend.sort((x: any, y: any) => y.netcost - x.netcost);
					return d;
				});
				setDistrictSpendByL4(res.data);

				let exportDistrictData: any = [];

				res.data.map((item: any) => {
					item.l4Spend.map((l: any) => {
						exportDistrictData.push({
							District: item.District,
							category: l.category,
							costPercent: l.costPercent,
							l1: l.l1,
							l2: l.l2,
							l3: l.l3,
						});
					});
				});

				// exportDistrictData.sort((x: any, y: any) => y.costPercent - x.costPercent);

				exportDistrictData.map((item: any) => {
					item.costPercent = `$${item.costPercent.toFixed(0)}`;
				});

				setDistrictSummaryExportData(exportDistrictData);
			}
		}
	};

	const getMapData = async (payload: any = {}) => {
		if (selectedCategories.L3) {
			payload = {
				l1: selectedCategories.L1
					? Array.isArray(selectedCategories.L1)
						? selectedCategories.L1
						: [selectedCategories.L1]
					: [],
				l2: selectedCategories.L2
					? Array.isArray(selectedCategories.L2)
						? selectedCategories.L2
						: [selectedCategories.L2]
					: [],
				l3: selectedCategories.L3
					? Array.isArray(selectedCategories.L3)
						? selectedCategories.L3
						: [selectedCategories.L3]
					: [],
				timeline: [selectedTimeline],
			};
			payload.projectType = selectedProjectType;
			payload.nofInd = selectedAddressableSpend;
			let res = await dispatch(getBaselineMapView(payload));
			if (res?.data) {
				/* res.data.sort((x: any, y: any) => y.totalSpendPrcntDistrict - x.totalSpendPrcntDistrict);
              res.data = res.data.map((d: any) => {
                  for (let cat of d.l4Spend) {
                      d[cat.category] = cat.costPercent;
                  }
                  d.l4Spend.sort((x: any, y: any) => y.costPercent - x.costPercent);
                  return d;
              }) */
				setMapData(res.data);

				//for getting sorted map legends based on cost
				let mapSupplierList: any = [];

				res.data[0]?.costData?.map((item: any) => {
					let s: any = {};
					s.supplier = item.supplier;
					s.cost = 0;
					s.color = item.color;
					mapSupplierList.push(s);
				});

				res.data.map((districtData: any) => {
					districtData.costData.map((supplierData: any) => {
						mapSupplierList.map((mlist: any) => {
							if (mlist.supplier == supplierData.supplier) {
								mlist.cost = mlist.cost + supplierData.cost;
							}
							if (mlist.supplier == "Rest") {
								mlist.cost = 0;
							}
						});
					});
				});

				mapSupplierList.sort((x: any, y: any) => y.cost - x.cost);
				setMapLegends(mapSupplierList);

				let mapExportData = JSON.parse(JSON.stringify(res?.data));

				mapExportData.map((d: any) => {
					d.costData.sort((x: any, y: any) => y.netcost - x.netcost);
					d.topNetCost = d.costData[0].netcost;
				});

				mapExportData.sort(
					(x: any, y: any) => y.topNetCost - x.topNetCost
				);

				let finalData: {
					district: any;
					supplier: any;
					netcost: any;
					l1: any;
					l2: any;
					l3: any;
				}[] = [];
				mapExportData.map((item: any) => {
					item.costData.map((ele: any) => {
						finalData.push({
							district: item.district,
							supplier: ele.supplier,
							netcost: ele.netcost,
							l1: ele.l1,
							l2: ele.l2,
							l3: ele.l3,
						});
					});
				});

				// finalData.sort((x: any, y: any) => y.netcost - x.netcost);

				finalData.map((item: any) => {
					item.netcost = `$${item.netcost.toFixed(0)}`;
				});

				setDistrictMapExportData(finalData);
			}
		}
	};

	const getParetoChartData = async (payload: any = {}) => {
		if (selectedCategories.L3) {
			payload = {
				l1: selectedCategories.L1
					? Array.isArray(selectedCategories.L1)
						? selectedCategories.L1
						: [selectedCategories.L1]
					: [],
				l2: selectedCategories.L2
					? Array.isArray(selectedCategories.L2)
						? selectedCategories.L2
						: [selectedCategories.L2]
					: [],
				l3: selectedCategories.L3
					? Array.isArray(selectedCategories.L3)
						? selectedCategories.L3
						: [selectedCategories.L3]
					: [],
				timeline: [selectedTimeline],
			};
			payload.projectType = selectedProjectType;
			payload.nofInd = selectedAddressableSpend;
			let res = await dispatch(getBaselineParetoChart(payload));
			if (res?.data) {
				res.data[0].coordinates.unshift({
					cumilativeMargin: 0,
					supplierNo: 0,
					cumilativeMarginRatio: 0,
					itemsNo: 0,
				});
				let rec = {};
				for (let d of res.data[0].coordinates) {
					if (d.cumilativeMarginRatio >= 80) {
						rec = d;
						break;
					}
				}

				setRefArea(rec);

				res.data[0].skuPareto[0].coordinates.unshift({
					cumilativeMargin: 0,
					itemsNo: 0,
				});
				let recSku = {};
				for (let d of res.data[0].skuPareto[0].coordinates) {
					if (d?.cumilativeMarginRatio >= 80) {
						recSku = d;
						break;
					}
				}

				setSkuRefArea(recSku);

				setPareto(res.data[0]);
			}
		}
	};

	const getSpaUtilSummary = async (payload: any = {}) => {
		if (selectedCategories.L3) {
			payload = {
				l1: selectedCategories.L1
					? Array.isArray(selectedCategories.L1)
						? selectedCategories.L1
						: [selectedCategories.L1]
					: [],
				l2: selectedCategories.L2
					? Array.isArray(selectedCategories.L2)
						? selectedCategories.L2
						: [selectedCategories.L2]
					: [],
				l3: selectedCategories.L3
					? Array.isArray(selectedCategories.L3)
						? selectedCategories.L3
						: [selectedCategories.L3]
					: [],
				timeline: [selectedTimeline],
			};
			payload.projectType = selectedProjectType;
			let res = await dispatch(getBaselineSPaUtilization(payload));
			let vendorRes = await dispatch(getBaselineVendorSpa(payload));
			if (res?.data) {
				setSpaUtilScatterData(res?.data);
				let spaExportData = JSON.parse(JSON.stringify(res?.data));
				spaExportData.sort(
					(x: any, y: any) => y.sales_2023 - x.sales_2023
				);
				spaExportData?.map((item: any, i: any) => {
					item.grossMargin = `${numberFormatter(
						item?.grossMargin * 100,
						2
					)}%`;
					item.sales_2023 = `$${item?.sales_2023?.toFixed(0)}`;
					item.spaPercent = `${numberFormatter(item.spaPercent, 2)}%`;
				});
				setSpaUtilizationExportData(spaExportData);
			}
			if (res?.gm) {
				let gmValue: any = res?.gm?.avgGrossMargin;
				gmValue = (gmValue * 100).toFixed(2);
				gmValue = Math.ceil(parseInt(gmValue) / 5) * 5;
				gmValue = gmValue / 100;
				setGetSpaGM(gmValue);
			}

			if (vendorRes?.data) {
				setSpaVendorData(vendorRes.data);
			}
		}
	};

	const handleL1Selection = (data: any) => {
		if (data == selectedCategories.L1 || data == null) {
			setSelectedCategories({ L1: null, L2: null, L3: null });
			setSelectedFilters({ ...selectedFilters, l1: [], l2: [], l3: [] });
			setUpdatedCategory(`l1_null`);
		} else {
			setSelectedCategories({ L1: data, L2: null, L3: null });
			setSelectedFilters({
				...selectedFilters,
				l1: [data],
				l2: [],
				l3: [],
			});
			setUpdatedCategory(`l1_${data}`);
		}
	};

	const handleL2Selection = (data: any) => {
		if (data == selectedCategories.L2 || data == null) {
			setSelectedCategories({
				...selectedCategories,
				L2: null,
				L3: null,
			});
			setSelectedFilters({ ...selectedFilters, l2: [], l3: [] });
			setUpdatedCategory(`l2_null`);
		} else {
			setSelectedCategories({
				...selectedCategories,
				L2: data,
				L3: null,
			});
			setSelectedFilters({ ...selectedFilters, l2: [data], l3: [] });
			setUpdatedCategory(`l2_${data}`);
		}
	};

	const handleL3Selection = (data: any) => {
		if (data == selectedCategories.L3 || data == null) {
			setSelectedCategories({ ...selectedCategories, L3: null });
			setSelectedFilters({ ...selectedFilters, l3: [] });
			setUpdatedCategory(`l3_null`);
		} else {
			setSelectedCategories({ ...selectedCategories, L3: data });
			setSelectedFilters({ ...selectedFilters, l3: [data] });
			setUpdatedCategory(`l3_${data}`);
		}
	};

	const scrollToSection = (sectionId: string) => {
		const element = document.getElementById(sectionId);
		if (element) {
			element.scrollIntoView({ behavior: "smooth" });
		} else {
			console.warn(`Element with id ${sectionId} not found.`);
		}
	};

	return isLoading ? (
		<Loader />
	) : (
		/* Container div */
		<div className="baseline-container w-full flex flex-col justify-start text-white overflow-auto">
			{/* Filter Div */}
			<div className="bg-[#F1F1F1] sticky flex flex-col gap-y-[1vh] top-0 z-[9999]">
				<MainHeader
					onVisibilityChange={setIsVisible}
					isRightVisible={isRightVisible}
					setIsRightVisible={setIsRightVisible}
					bottomContent={
						<>
							<div className="sub-heading-text font-bold flex flex-col items-start">
								<span className="filterHead ">Timeline</span>
								<SelectPicker
									data={
										timelineOptions.length
											? timelineOptions
											: []
									}
									placeholder="All"
									value={selectedTimeline}
									defaultValue={
										timelineOptions.length
											? timelineOptions[0].value
											: ""
									}
									onChange={timelineHandler}
									cleanable={false}
								/>
							</div>
							{selectedFilters &&
								["l1", "l2", "l3"].map(
									(filterEntity: string, index: number) => {
										return (
											<div
												className="sub-heading-text font-bold flex flex-col items-start"
												key={filterEntity}
											>
												<span className="filterHead">
													{filterEntity}
												</span>

												<CheckPicker
													data={
														filterOptions[
															filterEntity
														].length
															? filterOptions[
																	filterEntity
															  ]
															: []
													}
													placeholder="All"
													labelKey={filterEntity}
													valueKey={filterEntity}
													value={
														selectedFilters[
															filterEntity
														]
															? selectedFilters[
																	filterEntity
															  ]
															: []
													}
													onClose={() =>
														filtersMount.current
															? handleClose(
																	filterEntity
															  )
															: ""
													}
													onClean={() => {
														handleClear(
															filterEntity
														);
													}}
													onChange={(value: any) =>
														handleFilterUpdate(
															value,
															filterEntity
														)
													}
													loading={filtersLoading}
													renderExtraFooter={() => (
														<div
															style={footerStyles}
														>
															<Checkbox
																indeterminate={
																	selectedFilters[
																		filterEntity
																	]?.length >
																		0 &&
																	selectedFilters[
																		filterEntity
																	]?.length <
																		filterOptions[
																			filterEntity
																		]
																			?.length
																}
																checked={
																	selectedFilters[
																		filterEntity
																	]
																		?.length ===
																	filterOptions[
																		filterEntity
																	]?.length
																}
																onChange={(
																	value: any
																) =>
																	handleFilterUpdate(
																		"all",
																		filterEntity
																	)
																}
															>
																Check all
															</Checkbox>
														</div>
													)}
												/>
											</div>
										);
									}
								)}

							<div className="sub-heading-text font-bold flex flex-col items-start">
								<span className="filterHead ">
									Project Type
								</span>
								<SelectPicker
									data={projectType.length ? projectType : []}
									placeholder="All"
									value={selectedProjectType}
									
									defaultValue={
										projectType.length
											? projectType[0].value
											: ""
									}
									onChange={projectTypeHandler}
									cleanable={false}
								/>
							</div>
							<div className="sub-heading-text font-bold flex flex-col items-start">
								<span className="filterHead ">
									Addressable Spend
								</span>
								<SelectPicker
									data={
										addressableSpend.length
											? addressableSpend
											: []
									}
									placeholder="All"
									value={selectedAddressableSpend}
									
									defaultValue={
										addressableSpend.length
											? addressableSpend[0].value
											: ""
									}
									onChange={addressableSpendHandler}
									cleanable={false}
								/>
							</div>
						</>
					}
					topContent={
						<div className="flex justify-between items-center w-full">
							<div className="text-left pageline">
								<span className="pagelinestart">
									Baseline and Performance
								</span>{" "}
								<span className="pagelineslash">/</span>{" "}
								<span className="pagelinesub">
									Category Baseline
								</span>
							</div>
							<div className="flex items-center">
								<div className="execution-level-title">
									Scroll:
								</div>
								<Segmented
									options={[
										{
											label: "Category Summary",
											value: "category-summary",
										},
										{
											label: "Supplier Summary",
											value: "supplier-summary",
										},
										{
											label: "District Summary",
											value: "district-summary",
										},
										{
											label: "SKU Summary",
											value: "sku-summary",
										},
									]}
									value={selectedButton}
									onChange={(val: any) => {
										setSelectedButton(val);
										scrollToSection(val);
									}}
								/>
							</div>
						</div>
					}
				></MainHeader>
			</div>
			<MainContent isVisible={isVisible} fullHeight={true}>
				<div className="flex flex-col items-center w-full">
					<div className="flex justify-between gap-5 w-full mb-2">
						<div className="infocard">
							<div className="infocardHead">
								<span className="headerText">Spend</span>
							</div>
							<div className="contentText">
								{kpiData?.Total_Spend &&
									numberFormatter(
										kpiData?.Total_Spend,
										kpiData?.Total_Spend > 100000000 ? 1:
										0,
										"$"
									)}
							</div>
						</div>
						<div className="infocard">
							<div className="infocardHead">
								<span className="headerText">Sales</span>
							</div>
							<div className="contentText">
								{kpiData?.Total_Sales &&
									numberFormatter(
										kpiData?.Total_Sales,
										kpiData?.Total_Sales > 100000000 ? 1:
										0,
										"$"
									)}
							</div>
						</div>
						<div className="infocard">
							<div className="infocardHead">
								<span className="headerText">Gross Margin</span>
							</div>
							<div className="contentText">
								{kpiData?.Gross_Margin &&
									numberFormatter(kpiData?.Gross_Margin, 2)}
								%
							</div>
						</div>
						<div className="infocard">
							<div className="infocardHead">
								<span className="headerText">5-Year CAGR</span>
							</div>
							<div className="contentText">
								{kpiData?.cagr &&
									numberFormatter(kpiData?.cagr * 100, 2)}
								%
							</div>
						</div>
						<div className="infocard">
							<div className="infocardHead">
								<span className="headerText">NIA Earnings</span>
							</div>
							<div className="contentText">
								{kpiData?.Nia_Earnings &&
									numberFormatter(
										kpiData?.Nia_Earnings,
										kpiData?.Nia_Earnings > 100000000 ? 1:
										0,
										"$"
									)}
							</div>
						</div>
					</div>
				</div>

				<div
					className={`${
						!isVisible ? "h-[65vh]" : "h-[54vh]"
					} overflow-y-auto snap-y snap-mandatory gap-y-[2vw] flex flex-col mt-[0.8vh] scroll-smooth`}
				>
					<div className="snap-start h-[100%] bg-[#f9fafb] px-3 border-[1px] border-lightGrey shadow-md">
						<div className="headSpace">
							<div id="category-summary" className="headContent">
								Category Summary{" "}
								<span className="italic text-[#808080]">
									{getSelectedCategories()}
								</span>{" "}
							</div>
						</div>
						<div
							className={`flex flex-row w-full justify-between items-center gap-x-[1vw] ${
								!isVisible ? "h-[58vh]" : "h-[48vh]"
							} pt-1 pb-3`}
						>
							{Object.keys(categorySummary).length > 0 &&
								categorySummary.L1 && (
									<div className="p-2 w-full h-full grow-0 bg-white border-[0.5px] border-lightGrey">
										<L1Profile
											data={categorySummary.L1}
											selection={selectedCategories}
											handleClick={(data: any) => {
												handleL1Selection(data);
											}}
										></L1Profile>
									</div>
								)}
							{Object.keys(categorySummary).length > 0 &&
								categorySummary.L2 && (
									<div className="p-2 w-full h-full grow-0 bg-white border-[0.5px] border-lightGrey">
										<L2Profile
											data={categorySummary.L2}
											selection={selectedCategories}
											handleClick={(data: any) => {
												handleL2Selection(data);
											}}
										></L2Profile>
									</div>
								)}
							{Object.keys(categorySummary).length > 0 &&
								categorySummary.L3 && (
									<div className="p-2 w-full h-full grow-0 bg-white border-[0.5px] border-lightGrey">
										<L3Profile
											data={categorySummary.L3}
											selection={selectedCategories}
											handleClick={(data: any) => {
												handleL3Selection(data);
											}}
										></L3Profile>
									</div>
								)}
						</div>
					</div>
					<div className="snap-start h-[100%] bg-[#f9fafb] px-3 border-[1px] border-lightGrey shadow-md">
						<div className="headSpace">
							<div id="supplier-summary" className="headContent">
								Supplier Summary
								{(selectedCategories.L2 === null &&
									selectedCategories.L3 === null) ||
								supplierSummary.length === 0 ? (
									""
								) : (
									<span className="italic text-[#808080]">
										{getSelectedCategories()}
									</span>
								)}
							</div>
						</div>

						<div
							className={`flex flex-row w-full justify-between items-center gap-x-[1vw] ${
								!isVisible ? "h-[58vh]" : "h-[48vh]"
							} pt-1 pb-3`}
						>
							<div className="w-full h-full grow-0 overflow-auto p-0">
								{(selectedCategories.L2 === null &&
									selectedCategories.L3 === null) ||
								supplierSummary.length === 0 ? (
									<div className="msg-container h-[100%] flex justify-center items-center italic text-black text-[2.5vh] font-normal border-[0.5px] border-lightGrey bg-white">
										Please select the L2 Category to see the
										relevant data
									</div>
								) : (
									supplierSummary.length > 0 && (
										<SupplierSpendByCategory
											data={supplierSummary}
											exportData={supplierSummary}
											count={supplierSummaryCount}
											pageNumber={pageNumber}
											handleClick={(data: any) => {
												handleL3Selection(data);
											}}
											updatePageNumber={(page: any) => {
												getSupplierSummary({}, page);
											}}
										/>
									)
								)}
							</div>
							<div className="py-2 w-full h-full grow-0 overflow-auto px-3 border-[0.5px] border-lightGrey bg-white">
								{selectedCategories.L3 === null ||
								Object.keys(pareto).length === 0 ? (
									<div className="msg-container h-[100%] flex justify-center items-center italic text-black text-[2.5vh] font-normal">
										Please select the L3 Category to see the
										relevant data
									</div>
								) : (
									<SupplierPareto
										data={pareto}
										refArea={refArea}
									></SupplierPareto>
								)}
							</div>
						</div>
					</div>
					<div className="snap-start h-[100%] bg-[#f9fafb] px-3 border-[1px] border-lightGrey shadow-md">
						<div className="headSpace">
							<div id="district-summary" className="headContent">
								District Summary
								{selectedCategories.L3 === null ||
								mapData.length === 0 ? (
									""
								) : (
									<span className="italic text-[#808080]">
										{getSelectedCategories()}
									</span>
								)}
							</div>
						</div>

						<div
							className={` flex flex-row w-full justify-between items-center gap-x-[1vw] ${
								!isVisible ? "h-[58vh]" : "h-[48vh]"
							} pt-1 pb-3`}
						>
							<div className="py-2 w-full h-full grow-0 border-[0.5px] border-lightGrey bg-white overflow-auto">
								{selectedCategories.L3 === null ||
								mapData.length === 0 ? (
									<div className="msg-container h-[100%] flex justify-center items-center italic text-black text-[2.5vh] font-normal">
										Please select the L3 Category to see the
										relevant data
									</div>
								) : (
									<>
										<div className=" h-full px-2">
											<div className=" w-full flex flex-col">
												<div className="headSpace">
													<div className="headContent">
														TOP SUPPLIERS ACROSS
														DISTRICTS
													</div>

													<FileDownloadIcon
														className="mr-[2vh] mb-[1vh] cursor-pointer"
														style={{
															background:
																"#9acd32b8",
															borderRadius:
																".3vh",
														}}
														onClick={() => {
															exportMapData();
														}}
													/>
													<CSVLink
														ref={exportMapFullRef}
														data={
															districtMapExportData
														}
														headers={csvMapHeaders}
														filename="districtMap.csv"
														className="hidden"
														target="_blank"
													>
														{" "}
													</CSVLink>
												</div>
											</div>
											<div className="h-[78%]">
												<MapView data={mapData} />
											</div>
											<div className=" contentFooter legend-top-section w-full h-[10%] flex justify-center flex-row flex-wrap text-black text-xl ">
												{mapData[0]?.costData?.map(
													(d: any, i: any) => {
														return (
															<span
																className="flex items-center text-[50%] mr-[1vh]"
																key={i}
															>
																<span
																	className={`h-[15px] w-[15px] mx-4`}
																	key={`${i}_${d?.supplier}`}
																	style={{
																		background: `${d.color}`,
																	}}
																></span>
																{d?.supplier}
															</span>
														);
													}
												)}
											</div>
										</div>
									</>
								)}
							</div>
							<div className="w-full h-full grow-0 overflow-auto   bg-white ">
								{selectedCategories.L3 === null ||
								districtSpendByL4.length === 0 ? (
									<div className="msg-container h-[100%] flex justify-center items-center italic text-black text-[2.5vh] font-normal border-[0.5px] border-lightGrey bg-white">
										Please select the L3 Category to see the
										relevant data
									</div>
								) : (
									<DistrictSpendByL4
										data={districtSpendByL4}
										exportDistrictData={
											districtSummaryExportData
										}
										l3={selectedCategories.L3}
									></DistrictSpendByL4>
								)}
							</div>
						</div>
					</div>
					<div className="snap-start h-[100%]  bg-[#f9fafb]  px-3 border-[1px] border-lightGrey shadow-md">
						<div className="headSpace">
							<div id="category-summary" className="headContent">
								SKU Summary
								{selectedCategories.L3 === null ||
								Object.keys(pareto).length === 0 ? (
									""
								) : (
									<span className="italic text-[#808080]">
										{getSelectedCategories()}
									</span>
								)}
							</div>
						</div>
						<div
							className={`flex flex-row w-full justify-between items-center gap-x-[1vw] ${
								!isVisible ? "h-[58vh]" : "h-[48vh]"
							} pt-1 pb-3`}
						>
							<div className="w-full h-full grow overflow-auto border-[0.5px] border-lightGrey bg-white">
								{selectedCategories.L3 === null ||
								Object.keys(pareto).length === 0 ? (
									<div className="msg-container h-[100%] flex justify-center items-center italic text-black text-[2.5vh] font-normal">
										Please select the L3 Category to see the
										relevant data
									</div>
								) : (
									<SKUPareto
										data={pareto}
										refArea={skuRefArea}
										exportData={skuParetoExportData}
										getSkuExportData={() =>
											getSkuParetoExportData()
										}
										clearExport={() =>
											setSkuParetoExportData([])
										}
									></SKUPareto>
								)}
							</div>
							<div className="w-full h-full grow overflow-auto border-[0.5px] border-lightGrey bg-white">
								{selectedCategories.L3 === null ||
								Object.keys(pareto).length === 0 ? (
									<div className="msg-container h-[100%] flex justify-center items-center italic text-black text-[2.5vh] font-normal">
										Please select the L3 Category to see the
										relevant data
									</div>
								) : (
									<L4SummaryTable data={l4SummaryData} />
								)}
							</div>
						</div>
					</div>

					<div className="snap-start h-[100%]  bg-[#f9fafb] px-3 border-[1px] border-lightGrey shadow-md">
						<div className="headSpace">
							<div id="sku-summary" className="headContent">
								SKU Summary
								{selectedCategories.L3 === null ||
								Object.keys(pareto).length === 0 ? (
									""
								) : (
									<span className="italic text-[#808080]">
										{getSelectedCategories()}
									</span>
								)}
							</div>
						</div>
						<div
							className={`flex flex-row w-full justify-between items-center gap-x-[1vw] ${
								!isVisible ? "h-[58vh]" : "h-[48vh]"
							} pt-1 pb-3`}
						>
							<div className="w-full h-full grow overflow-auto border-[0.5px] border-lightGrey bg-white py-2">
								{selectedCategories.L3 === null ? (
									<div className="msg-container h-[100%] flex justify-center items-center italic text-black text-[2.5vh] font-normal">
										Please select the L3 Category to see the
										relevant data
									</div>
								) : (
									<>
										<div className=" w-full flex flex-col px-2">
											<div className="headSpace">
												<div className="headContent">
													SPA UTILIZATION BY SKUs
													(%LINE-ITEM TRANSACTION w
													SPA)
												</div>

												<FileDownloadIcon
													className="mr-[2vh] cursor-pointer"
													style={{
														background: "#9acd32b8",
														borderRadius: ".3vh",
													}}
													onClick={() => {
														exportData();
													}}
												/>
												<CSVLink
													ref={exportFullRef}
													data={
														spaUtilizationExportData
													}
													headers={csvHeaders}
													filename="spaUtilization.csv"
													className="hidden"
													target="_blank"
												>
													{" "}
												</CSVLink>
											</div>
										</div>
										<div>
											<div className="rotate-[-90deg] relative left-[-21vh] w-[41vh] h-[0vh] top-[16.5vh] text-[1.7vh] text-[#818080]">
												% of Line-Item Transactions with
												SPA Applied
											</div>
											<BubbleChart
												gmValue={getSpaGM}
												Graphdata={spaUtilScatterData}
											/>
										</div>
									</>
								)}
							</div>
							<div className="w-full h-full grow overflow-auto  bg-white">
								{selectedCategories.L3 === null ? (
									<div className="msg-container h-[100%] flex justify-center items-center italic text-black text-[2.5vh] font-normal border-[0.5px] border-lightGrey bg-white">
										Please select the L3 Category to see the
										relevant data
									</div>
								) : (
									<SKUCountTable
										data={spaVendorData}
									></SKUCountTable>
								)}
							</div>
						</div>
					</div>
				</div>
			</MainContent>
		</div>
	);
};

const mapDispatchToProps = (dispatch: any) => ({
	onFilterChange: (data: any) => dispatch({ type: FILTERDATA, data: data }),
	onTimelineChange: (data: any) => dispatch({ type: TIMELINE, data: data }),
});

export default connect(null, mapDispatchToProps)(CategoryBaseline);
